import React from "react"
import classNames from "classnames"
import type { StoreSchedule } from "scripts/types"
import { DayName } from "scripts/types"

export default function ScheduleTable(props: {
  storeSchedule: StoreSchedule
  phrases: {
    days: {
      [key in DayName]: string
    }
    day_off: string
  }
  className?: string
}) {
  const { storeSchedule, phrases, className = "" } = props
  const schedule = storeSchedule.schedule

  const classNameDay = (day: string, dayOff: boolean): string => {
    let className = ""
    storeSchedule.todayName === day && (className += " today")
    dayOff && (className += " day-off")
    return className
  }

  const tableClasses = classNames("schedule-table", className, {
    closed: !storeSchedule.isOpen,
  })

  return (
    <table className={tableClasses}>
      <tbody>
        {Object.values(DayName).map((day) => (
          <tr className={classNameDay(day, !Boolean(schedule[day][0]))} key={day}>
            <td>{phrases?.days?.[day] || day.slice(0, 2)}</td>
            <td>
              <b>{schedule[day][0] || phrases["day_off"] || "Day off"}</b>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
